"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const IUserAuthStateService_interface_1 = require("../interfaces/IUserAuthStateService.interface");
const _ = require("underscore");
let UserLevelCheckDirective = class UserLevelCheckDirective {
    constructor(_el, _userAuthStateService) {
        this._el = _el;
        this._userAuthStateService = _userAuthStateService;
    }
    ngOnInit() {
        this.doLevelCheck();
    }
    doLevelCheck() {
        this._userAuthStateService.checkRequestedLevel(this.requiredUserLevel, (username, level, success) => {
            if (!success) {
                this.disableHostElement();
            }
            else {
                this.enableHostElement();
            }
        });
    }
    disableHostElement() {
        if (this._el.nativeElement.disabled) {
            return;
        }
        let overlayContainer = null;
        let overlaySizeTemplate = null;
        if (this._el.nativeElement instanceof HTMLUnknownElement) {
            overlayContainer = $(this._el.nativeElement.firstElementChild);
            overlaySizeTemplate = overlayContainer;
        }
        else {
            overlayContainer = $(this._el.nativeElement.parentElement);
            overlaySizeTemplate = $(this._el.nativeElement);
        }
        this._overlayId = _.uniqueId();
        let overlay = $("<div id='" + this._overlayId + "' />");
        overlay.css({
            position: "absolute",
            top: overlaySizeTemplate.position().top,
            left: overlaySizeTemplate.position().left,
            width: overlaySizeTemplate.outerWidth(),
            height: overlaySizeTemplate.outerHeight(),
            zIndex: overlaySizeTemplate.css("z-index") + 1,
            backgroundColor: "#fff",
            opacity: 0
        });
        overlay.on('click', (e, args) => {
            this.doLevelCheck();
        });
        overlayContainer.append(overlay);
        this._el.nativeElement.disabled = true;
    }
    enableHostElement() {
        if (!this._el.nativeElement.disabled) {
            return;
        }
        $("div[id=" + this._overlayId + "]").remove();
        this._el.nativeElement.disabled = false;
    }
};
__decorate([
    core_1.Input('userLevelCheck'),
    __metadata("design:type", String)
], UserLevelCheckDirective.prototype, "requiredUserLevel", void 0);
UserLevelCheckDirective = __decorate([
    core_1.Directive({
        selector: '[userLevelCheck]'
    }),
    __param(1, core_1.Inject(IUserAuthStateService_interface_1.IUSERAUTHSTATESERVICE_TOKEN)),
    __metadata("design:paramtypes", [core_1.ElementRef, Object])
], UserLevelCheckDirective);
exports.UserLevelCheckDirective = UserLevelCheckDirective;
